<template>
  <div class="legend-item">
    <div>
      <span class="legend-label">{{ $t(legend.label) }}</span>
      <span class="legend-subtitle">({{ $t(legend.subTitle) }})</span>
    </div>
    <div class="legend-values">
      <div  v-for="threshold in [...legend.thresholds].reverse()"
            :key="threshold.label"
            class="legend-value">
        <component  v-if="threshold.icon"
                    :is="threshold.icon"
                    :size="12"
                    class="value-icon" />
        <div  v-else
              class="color-indicator"
              :style="{ backgroundColor: threshold.color }">
        </div>
        <span class="value-text">{{ Math.trunc(threshold.min) }}-{{ Math.trunc(threshold.max) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LegendItem',

  props: {
    legend: { type: Object, required: true }
  }
};
</script>

<style lang="scss" scoped>
.legend-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 10rem;
}

.legend-label {
  font-size: 11px;
  font-weight: 600;
  color: var(--bs-body-color);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.legend-subtitle {
  font-size: 10px;
  font-weight: 300;
  color: var(--bs-secondary-color);
  letter-spacing: 0.00em;
}

.legend-values {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
}

.legend-value {
  display: flex;
  align-items: center;
  gap: 6px;
}

.color-indicator {
  width: 4px;
  height: 14px;
  border-radius: var(--radius-xs);
}

.value-icon {
  flex-shrink: 0;
  color: var(--bs-secondary-color);
}

.value-text {
  font-size: 0.6875rem;
  color: var(--bs-secondary-color);
}
</style>
